import { Datepicker } from '@zendeskgarden/react-datepickers'
import { Field, Input, Label } from '@zendeskgarden/react-forms'
import { Body, Modal } from '@zendeskgarden/react-modals'
import moment from 'moment'
import React, { useState } from 'react'

import ButtonV2 from '../app/design/Button'
import ChevronLeftIcon from '../../icons/ps_reporting_chevron_left.svg?react'
import CloseIcon from '../../icons/ps_reporting_close.svg?react'

type Props = {
    startDate?: moment.Moment
    endDate?: moment.Moment
    onDone: (startDate: moment.Moment, endDate: moment.Moment) => void
    onClose: () => void
    onBack?: () => void
}

export const ReportSelectDateModal = ({ startDate, endDate, onDone, onClose, onBack }: Props) => {
    const [selectedStartDate, setSelectedStartDate] = useState<moment.Moment | undefined>(
        startDate || undefined
    )
    const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | undefined>(
        endDate || undefined
    )

    const handleDone = () => {
        if (selectedStartDate && selectedEndDate) {
            onDone(selectedStartDate, selectedEndDate)
        }
    }

    return (
        <Modal aria-label="Select date modal" className="reportSelectModal" onClose={onClose}>
            <div className="header">
                {onBack && (
                    <button className="back" onClick={onBack} tabIndex={0}>
                        <ChevronLeftIcon color="#314A68" />
                    </button>
                )}
                <div className={`title`}>Pick custom dates</div>
                <button className="close" tabIndex={0} onClick={onClose}>
                    <CloseIcon color="#314A68" />
                </button>
            </div>

            <Body className="selectDateBody">
                <div className="fields">
                    <Field>
                        <Label>Start Date</Label>
                        <Datepicker
                            isCompact={true}
                            value={
                                selectedStartDate && moment.isMoment(selectedStartDate)
                                    ? selectedStartDate.toDate()
                                    : undefined
                            }
                            onChange={(date: Date) => setSelectedStartDate(moment(date))}
                        >
                            <Input />
                        </Datepicker>
                    </Field>
                    <Field>
                        <Label>End Date</Label>
                        <Datepicker
                            isCompact={true}
                            value={
                                selectedEndDate && moment.isMoment(selectedEndDate)
                                    ? selectedEndDate.toDate()
                                    : undefined
                            }
                            onChange={(date: Date) => setSelectedEndDate(moment(date))}
                        >
                            <Input />
                        </Datepicker>
                    </Field>
                </div>
                <div className="selectDateFooter">
                    <ButtonV2 intent="secondary" onClick={onClose}>
                        Cancel
                    </ButtonV2>
                    <ButtonV2
                        intent="primary"
                        onClick={handleDone}
                        disabled={!selectedStartDate || !selectedEndDate}
                    >
                        Done
                    </ButtonV2>
                </div>
            </Body>
        </Modal>
    )
}
